import {bulkExportLinksOrder} from "../../../../../services/api/3dApi"

export default function (props) {
    const {query} = props
    const {type = '', size = '', total_item} = query

    let rqUrl = ''

    const limit = window.prompt('Nhập số lượng item:', 50)

    const vLimit = parseInt(limit, 10)

    rqUrl += `?limit=${vLimit}`

    if (type) {
        rqUrl += `&type=${type}`
    }

    if (size) {
        rqUrl += `&size=${size}`
    }

    if (total_item) {
        rqUrl += `&total_item=${total_item}`
    }

    if (limit !== null) {
        window.open(bulkExportLinksOrder(rqUrl))
    }
}
